import React, { useState, useContext, useEffect } from 'react';
import SeatsDisplay from './SeatsDisplay';
import useWindowDimensions from '../../theme/useWindowDimensions';
import RoomContext from '../../services/roomContext';
import { useSelector, useDispatch } from 'react-redux';
import { updateBoxName, updateOnlyBoxes } from '../../redux/streamInfoSlice';
import {
  updateFirstWave,
  updateCurrBoxNSeat,
} from '../../redux/movingBoxSlice';
import Container from '@material-ui/core/Container';
import TableArea from './TableArea';

import Services from '../../services/services';
import toast, { Toaster } from 'react-hot-toast';
import { layoutImgDims } from './../../constants';
import { getUserBrowserStorage } from '../../constants';

function Index({ onCloseModal }) {
  const [seatsArr, setSeatsArr] = useState([]);
  const [showSeats, setShowSeats] = useState(false);
  const [layoutCoords, setLayoutCoords] = useState({});
  const { rooms, setRooms } = useContext(RoomContext);
  const dispatch = useDispatch();
  const streamInfo = useSelector((state) => state.streamInfo);
  const movingBox = useSelector((state) => state.movingBox);
  const actualBox = streamInfo?.boxName.replace(streamInfo?.globalName, '');
  const defBoxId = streamInfo.defaultSeatBox?.boxId;

  const userDetails = JSON.parse(getUserBrowserStorage('userDetails'));
  const firstName = userDetails?.firstName;
  const lastName = userDetails?.lastName;
  const participantName = firstName + (lastName ? ' ' + lastName : '');

  const { height, width } = useWindowDimensions();

  const layoutImgWidth = layoutImgDims[streamInfo?.eventLayoutId || 1]['width'];
  const layoutImgHeight = layoutImgDims[streamInfo?.eventLayoutId || 1]['height'];

  useEffect(() => {
    getBoxDetails();
    getLayoutCoords();
  }, []);

  const getLayoutCoords = async () => {
    const res = await Services.layout_coords(streamInfo?.eventLayoutId || 1);
    const resOfCoords = res.data.layoutDetails[0]['layoutCordinate'];
    setLayoutCoords(resOfCoords);
    // (resOfCoords, 'This is cordinate response')
  };

  const boxMovingSeatAssign = async (seat) => {
    //seat moving final func
    toast.dismiss();
    const toastId = toast.success('Arranging your seat..');
    const defSeatBox =
      movingBox.currBoxID === defBoxId &&
      movingBox.currSeatID === streamInfo.defaultSeatBox?.seatId;
    const movingFinData = {
      userId: userDetails.userId,
      oldBoxId: movingBox.currBoxID,
      newBoxId: movingBox.newBoxID,
      eventId: streamInfo.eventID,
      oldSeatId: movingBox.currSeatID,
      newSeatName: seat.seatName,
      defaultSeat: defSeatBox,
    };
    try {
      const res = await Services.box_moving_seatAssign(movingFinData);
      // 'seat assign response from backend'
      if (res.data.responseCode === 200) {
        toast.dismiss();
        toast.success('All set! Taking you there in a moment', {
          duration: 2000,
          id: toastId,
        });
        const boxDetails = res.data.boxDetails;
        dispatch(
          updateCurrBoxNSeat({
            boxID: boxDetails.newBoxId,
            seatID: boxDetails.newSeatId,
            boxSid: movingBox.newBoxChatSID,
            boxName: movingBox.newBoxName,
          })
        );
        // 'current box and seat ids updated'
        const newBoxRoomName = streamInfo?.globalName + movingBox.newBoxName;
        dispatch(updateBoxName({ boxRoomName: newBoxRoomName }));
        setShowSeats(false);
        try {
          rooms.activeBConversation.leave();
          rooms.activeBoxRoom?.disconnect();
        } catch (error) {
          console.log(error, 'error in leaving');
        }
        rooms?.handleRoomChange(
          newBoxRoomName,
          movingBox.newBoxChatSID,
          toastId,
          participantName
        ); //this function is in videochat.js
        onCloseModal();
      } else {
        toast.dismiss();
        toast.error('Error! Try Again', { duration: 4000, id: toastId });
      }
    } catch (error) {
      toast.dismiss();
      toast.error('Oops! Try Again', { duration: 4000, id: toastId });
    }
  };

  const getSeatDetails = async (eventId, boxId, toastId) => {
    // "Loading seats.."
    try {
      const res = await Services.seat_Info(eventId, boxId);
      if (res.data.responseCode === 200) {
        toast.dismiss();
        toast.success('Select a seat', { duration: 2000, id: toastId });
        await setSeatsArr(res.data.seatNumber);
        setShowSeats(true);
        document.getElementById('disuniquescrolllimits').scrollTop = 0;
        document.getElementById('disuniquescrolllimits').scrollLeft = 0;
      } else {
        toast.dismiss();
        toast.error('Error! Try again.', { duration: 4000, id: toastId });
      }
    } catch (error) {
      toast.dismiss();
      toast.error('Error! Try again.', { duration: 4000, id: toastId });
    }
  };

  const boxMovingApi = async (box, eventID, toastId) => {
    const movingDetails = {
      userId: userDetails?.userId,
      eventId: eventID,
      boxName: box['boxName'],
      boxId: null,
    };
    const res = await Services.box_moving(movingDetails);
    const data = res.data.boxDetails;
    dispatch(
      updateFirstWave({
        newBoxID: data.newBoxId,
        newBoxName: box['boxName'],
        newBoxChatSID: data.boxChatChannelSID,
      })
    );
    getSeatDetails(eventID, data.newBoxId, toastId);
  };

  const funcBoxHasChatSid = (box, eventID, toastId) => {
    const newBoxId = box['boxId'];
    dispatch(
      updateFirstWave({
        newBoxID: newBoxId,
        newBoxName: box['boxName'],
        newBoxChatSID: box['boxChatChannelSID'],
      })
    );

    getSeatDetails(eventID, newBoxId, toastId);
  };

  const getBoxDetails = async () => {
    try {
      const res = await Services.get_box_details(
        streamInfo?.createdBy,
        streamInfo.eventID
      );
      if (res.data.responseCode === 200) {
        dispatch(updateOnlyBoxes({ boxDetails: res.data.Boxes }));
        return res.data.Boxes;
      } else {
        toast.error('Error getting tables');
      }
    } catch (error) {}
  };

  const funcGetAndCheckBoxSid = async (box) => {
    toast.dismiss();
    const toastId = toast.loading('Please wait.. Updating table');
    const updatedBoxes = await getBoxDetails();
    const match = updatedBoxes.find((newBox) => {
      if (newBox['boxName'] === box['boxName']) {
        const res = newBox['boxChatChannelSID']?.length ? true : false;
        return res;
      } else {
        return false;
      }
    });
    if (match) {
      funcBoxHasChatSid(match, streamInfo.eventID, toastId);
      return;
    } else {
      boxMovingApi(box, streamInfo.eventID, toastId);
    }
  };

  const handleBoxUiClick = (box, allowClick, sameBox) => {
    if (sameBox) {
      toast.dismiss();
      toast.success('Already inside');
      return null;
    } else if (!allowClick) {
      toast.dismiss();
      toast.error('Sorry! No Entry!');
      // 'cant click'
      return null;
    } else if (box['boxChatChannelSID']?.length) {
      if (!allowClick) {
        return null;
      } else {
        // 'seems this box having old chat sid already'
        funcBoxHasChatSid(box, streamInfo.eventID);
        return;
      }
    } else {
      // 'Okay, can click this'
      funcGetAndCheckBoxSid(box);
      return;
    }
  };

  const AllowClick = (sameBox, box) => {
    const temp = box['boxName'] !== streamInfo.defaultBoxName;
    const realReservedBox =
      box['isBoxAssign'] === 'Y' && box['isBoxPublic'] === false;
    if (sameBox) {
      // "cant click same box you're in"
      return false;
    } else if (realReservedBox && temp) {
      // "cant go to reserved boxes"
      return false;
    } else {
      return true;
    }
  };

  const renderTableArea = (box) => {
    if (
      Object.keys(layoutCoords).length &&
      layoutCoords[box['boxName']]?.length
    ) {
      const sameBox = actualBox === box['boxName'] ? true : false;
      const allowClick = AllowClick(sameBox, box);
      const coords = layoutCoords[box['boxName']];
      const imgWidth = parseInt(layoutImgWidth);
      const imgHeight = parseInt(layoutImgHeight);
      const addPadLeft = width * 0.9 - imgWidth;
      const addPadTop = height * 0.9 - imgHeight;
      // const actualAdd = addPadLeft > 0 ? addPadLeft * 0.5 : 0;
      // const actualAddH = addPadTop > 0 ? addPadTop * 0.5 : 0;
      const actualAdd = 0;
      const actualAddH = 0;
      return (
        <TableArea
          key={box['boxName']}
          allowClick={allowClick}
          box={box}
          handleBoxUiClick={handleBoxUiClick}
          sameBox={sameBox}
          defaultBox={defBoxId === box['boxId']}
          coords={coords}
          actualAdd={actualAdd}
          actualAddH={actualAddH}
        />
      );
    }
    return null;
  };

  return (
    <Container
      style={{
        position: 'relative',
        textAlign: 'center',
        height: '100%',
      }}
    >
      <div
        style={{
          display: 'grid',
          placeItems: 'center',
          height: '100%',
        }}
      >
        <img
          src={
            streamInfo?.eventLayoutUrl
              ? Services.event_logo_URL() + streamInfo.eventLayoutUrl
              : `/assets/images/layout${streamInfo?.eventLayoutId || 1}.png`
          }
          alt="layout arrangement"
          width={layoutImgWidth}
          height={layoutImgHeight}
          useMap="#workmap"
        />
      </div>
      <map name="workmap">
        {streamInfo?.boxDetails.map((box) => renderTableArea(box))}
      </map>

      {!showSeats && !seatsArr.length ? null : (
        <div
          style={{
            position: 'absolute',
            top: 20,
            right: 20,
            left: 20,
            bottom: 20,
          }}
        >
          <SeatsDisplay
            setShowSeats={setShowSeats}
            seatsArr={seatsArr}
            boxMovingSeatAssign={boxMovingSeatAssign}
            setSeatsArr={setSeatsArr}
          />
        </div>
      )}
      <Toaster position="top-center"></Toaster>
    </Container>
  );
}

export default Index;

// isBoxAssign :Y && isBoxPublic:false -- disable
// isBoxAssign :N && isBoxPublic:false -- enable
// isBoxAssign :Y && isBoxPublic:true -- enable
// isBoxAssign :N && isBoxPublic:true -- enable
